export const logDev = (...args) => {
  /*if (process.env.NODE_ENV === "development") {*/
  if (process.env.REACT_APP_DEBUG === "true") {
    console.debug("🛠️ [logDev]", ...args);
  }
};
